var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloneSeqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.6553,
    y: 35.0078,
    width: 4.91736,
    height: 30.4876,
    transform: "rotate(90 53.6553 35.0078)",
    fill: "#1976D2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.6553,
    y: 53.6953,
    width: 4.91736,
    height: 30.4876,
    transform: "rotate(90 53.6553 53.6953)",
    fill: "#1976D2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.8373,
    y: 44.8438,
    width: 3.93389,
    height: 19.6694,
    transform: "rotate(90 42.8373 44.8438)",
    fill: "#1976D2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42.8373,
    y: 26.1582,
    width: 4.91736,
    height: 19.6694,
    transform: "rotate(90 42.8373 26.1582)",
    fill: "#1976D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6852 6.48828H15.8066V67.4635H62V14.8031M53.6852 6.48828V14.8031H62M53.6852 6.48828L62 14.8031",
    stroke: "#1976D2",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneSeqIcon);
export default __webpack_public_path__ + "static/media/CloneSeqIcon.0280cb5aea3ddf5f2cb528198680f5b0.svg";
export { ForwardRef as ReactComponent };